// extracted by mini-css-extract-plugin
export default {"continer":"GuidesDesigners_continer__YYEYw","text_continer":"GuidesDesigners_text_continer__CaPog"};